import React from 'react'
import { useSelector } from 'react-redux'
import MovieList from "./MovieList"

const GPTMovieSuggestion = () => {
  const {movieResults, movieNames} = useSelector(store => store.gpt)
  if(!movieNames || !movieResults) return 
  return (
    <div className='p-4 m-4 bg-black text-white bg-opacity-80'>
      <div>
        {movieNames.map((movie, index)=> <MovieList key={movie} title={movie} movies={movieResults[index]}/>)}
      </div>
    </div>
  )
} 

export default GPTMovieSuggestion